import React from 'react'
import {DownloadFile} from 'jbc-front/components/icons'
import styles from './DownloadFileIcon.scss'

export const DownloadFileIcon = () => <DownloadFile size={14} color="#fff" className={styles.downloadFileIcon} />
